import { ABSTRACT_CONDITION_TYPES } from '../consts/abstractConditionTypes'
import { ARG_TYPES } from '../consts/argTypes'

/* todo
export function stringComparison() {
  return {
    type: 'STRING_COMPARISON',
    name:'String comparison',
    description:'{arg0:string} is equal to {arg1:string}',
    argTypes:['STRING', 'STRING'],
    returnType:'CONDITION'
  }
}
*/

export function integerComparison() {
  return {
    type: ABSTRACT_CONDITION_TYPES.INTEGER_COMPARISON,
    name:'Integer comparison',
    description:'{arg0:Integer} is {arg1:comparator} to {arg2:value}',
    argTypes:[ARG_TYPES.INTEGER, ARG_TYPES.INTEGER_COMPARATOR, ARG_TYPES.INTEGER],
    returnType:ARG_TYPES.CONDITION
  }
}

export function statusComparison() {
  return {
    type: ABSTRACT_CONDITION_TYPES.STATUS_COMPARISON,
    name:'Status comparison',
    description:'The game status is {arg0:status}',
    argTypes:[ARG_TYPES.STATUS],
    returnType:ARG_TYPES.CONDITION
  }
}

export function languageComparison() {
  return {
    type: ABSTRACT_CONDITION_TYPES.LANGUAGE_COMPARISON,
    name:'Language comparison',
    description:'The language is {arg0:Language}',
    argTypes:[ARG_TYPES.LANGUAGE],
    returnType:ARG_TYPES.CONDITION
  }
}


export function gpioComparison() {
  return {
    type: ABSTRACT_CONDITION_TYPES.GPIO_COMPARISON,
    name: 'Input comparison',
    description: 'The pin {arg0:pin} is equal to {arg1:boolean}',
    argTypes:[ARG_TYPES.FIXTURE_INPUT, ARG_TYPES.BOOLEAN],
    returnType:ARG_TYPES.CONDITION
  }
}

export function orComparison() {
  return {
    type: ABSTRACT_CONDITION_TYPES.OR_COMPARISON,
    name: 'Or comparison',
    description: '{arg0:condition1} or {arg1:condition2}',
    argTypes:[ARG_TYPES.CONDITION, ARG_TYPES.CONDITION],
    returnType:ARG_TYPES.CONDITION
  }
}

export function andComparison() {
  return {
    type: ABSTRACT_CONDITION_TYPES.AND_COMPARISON,
    name: 'And comparison',
    description: '{arg0:condition1} and {arg1:condition2}',
    argTypes:[ARG_TYPES.CONDITION, ARG_TYPES.CONDITION],
    returnType:ARG_TYPES.CONDITION
  }
}

// TODO
export function BooleanComparison() {
  return {
    type: ABSTRACT_CONDITION_TYPES.BOOLEAN_COMPARISON,
    name: 'Boolean Comparison',
    description: '{arg0:boolean1} {arg1:comparator} {arg2:boolean2}',
    argTypes:[ARG_TYPES.BOOLEAN, ARG_TYPES.BOOLEAN_COMPARATOR, ARG_TYPES.BOOLEAN],
    returnType:ARG_TYPES.CONDITION
  }
}